"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Generated API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleAuthorizationApi = exports.GoogleAuthorizationApiFactory = exports.GoogleAuthorizationApiFp = exports.GoogleAuthorizationApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * GoogleAuthorizationApi - axios parameter creator
 * @export
 */
const GoogleAuthorizationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [code]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleAuthorizationEndpointGetAndStoreCredential: (code_1, ...args_1) => __awaiter(this, [code_1, ...args_1], void 0, function* (code, options = {}) {
            const localVarPath = `/google/store/calendar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.GoogleAuthorizationApiAxiosParamCreator = GoogleAuthorizationApiAxiosParamCreator;
/**
 * GoogleAuthorizationApi - functional programming interface
 * @export
 */
const GoogleAuthorizationApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.GoogleAuthorizationApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} [code]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleAuthorizationEndpointGetAndStoreCredential(code, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.googleAuthorizationEndpointGetAndStoreCredential(code, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['GoogleAuthorizationApi.googleAuthorizationEndpointGetAndStoreCredential']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.GoogleAuthorizationApiFp = GoogleAuthorizationApiFp;
/**
 * GoogleAuthorizationApi - factory interface
 * @export
 */
const GoogleAuthorizationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.GoogleAuthorizationApiFp)(configuration);
    return {
        /**
         *
         * @param {GoogleAuthorizationApiGoogleAuthorizationEndpointGetAndStoreCredentialRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleAuthorizationEndpointGetAndStoreCredential(requestParameters = {}, options) {
            return localVarFp.googleAuthorizationEndpointGetAndStoreCredential(requestParameters.code, options).then((request) => request(axios, basePath));
        },
    };
};
exports.GoogleAuthorizationApiFactory = GoogleAuthorizationApiFactory;
/**
 * GoogleAuthorizationApi - object-oriented interface
 * @export
 * @class GoogleAuthorizationApi
 * @extends {BaseAPI}
 */
class GoogleAuthorizationApi extends base_1.BaseAPI {
    /**
     *
     * @param {GoogleAuthorizationApiGoogleAuthorizationEndpointGetAndStoreCredentialRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoogleAuthorizationApi
     */
    googleAuthorizationEndpointGetAndStoreCredential(requestParameters = {}, options) {
        return (0, exports.GoogleAuthorizationApiFp)(this.configuration).googleAuthorizationEndpointGetAndStoreCredential(requestParameters.code, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.GoogleAuthorizationApi = GoogleAuthorizationApi;
//# sourceMappingURL=google-authorization-api.js.map